import tw, { styled } from 'twin.macro';
import Sticky from 'react-stickynode';
import Link from '@/components/Link/Link';
import { StyledLink } from '@/components/Link/Link.styles';
import {
  SecondaryMenuWrapper,
  StyledToggle,
} from './components/SecondaryNavigationMenu/SecondaryNavigationMenu.styles';

import { StyledTitle } from '../Header/components/MenuItem/MenuItem.styles';

export const SECONDARY_NAVIGATION_FRAGMENT_STICKY_HEIGHT = '64';

export const StyledContainer = styled.div`
  ${tw`lg:max-w-[100vw] lg:min-w-[calc(1120px - 66px)] lg:w-auto`}
  ${tw`lg:mx-auto`}
  ${tw`text-center`}


  ${tw`lg:container-stack-context`}
  ${tw`flex`}

  ${StyledToggle} {
    ${tw`order-4 lg:order-none`}
  }
`;
export const StyledActiveTitle = styled.h3`
  ${tw`font-inter`}
  ${tw`break-all`}
  ${tw`text-tag-m font-semi-bold text-left lg:normal-case`}
  ${tw`pt-0 pr-2 lg:pr-0 lg:pt-2`}
  ${tw`block lg:hidden`}
  ${tw`my-auto`}
`;

export const CTASectionDesktop = styled.div`
  ${tw`hidden lg:flex lg:gap-[20px]`}
  ${tw`my-auto md:mr-[8px] lg:mr-[2px] lg:pt-0 lg:mb-[12px]`}
  ${tw`order-3 lg:order-none`}
  ${tw`transition-[max-width,opacity] duration-1000`}
`;

export const CTASectionMobile = styled.div`
  ${tw`flex flex-col lg:flex-row lg:hidden`}
  ${tw`items-center lg:justify-center`}
  ${tw`py-2`}
  ${tw`bg-neutrals-n1`}
`;

export const StyledCTA = styled(Link)`
  ${tw`my-auto`}
  ${tw`lg:first-of-type:ml-6 last-of-type:lg:mr-0 lg:mt-[9px]`}
`;

export const StyledSecondaryMenuItem = styled(Link)<{
  isActive: boolean;
}>`
  ${tw`block lg:inline-block`}
  ${tw`relative`}
  ${tw`lg:normal-case text-primary-p1 text-left`}
  ${tw`pl-[21px] lg:pl-0`}
  ${tw`py-3 lg:py-[22px]`}
  ${({ isActive }) => isActive && tw`lg:after:bg-none lg:after:scale-x-100`}
`;

// Let's hide the search for now
// Until we completely remove the blog search and use global search
export const SearchSectionMobile = styled.div`
  ${tw`hidden`}
  ${tw`text-center`}
  ${tw`py-2 px-[20px]`}
  ${tw`bg-neutrals-n1`}
  ${tw`relative`}
`;

export const SearchSectionDesktop = styled.div`
  ${tw`hidden`}
`;

export const SecondaryMenu = styled.ul`
  ${tw`py-[10px] lg:py-0`}
  ${tw`lg:text-right`}
  ${tw`bg-neutrals-n1 lg:bg-[transparent]`}
  ${tw`lg:flex lg:gap-6`}
`;

export const SecondaryMenuItem = styled.li`
  & > button {
    ${tw`h-full`}
  }

  &:first-of-type ${StyledTitle}, &:first-child ${StyledLink} {
    ${tw`text-ui-colours-ui2`}
  }
`;

export const StyledSection = styled.section`
  ${tw`w-full`}
  ${tw`min-h-[74px] lg:min-h-[unset] lg:h-[unset]`}
  ${tw`border-b border-[transparent]`}
  ${tw`bg-neutrals-n1`}
  ${tw`px-[21px] md:pr-[29px] lg:px-[33px]`}
  ${tw`grid items-center`}

  &, ${StyledContainer}, ${StyledSecondaryMenuItem}, ${SecondaryMenuWrapper} {
    ${tw`transition-all duration-100`}
  }
`;

export const StyledSticky = styled(Sticky)<{ showCTAsOnScroll: boolean }>`
  ${StyledSection} {
    ${tw`border-b-2 border-neutrals-n7`}
  }

  .isSticky ${StyledSection} {
    ${tw`lg:h-[63px]`}
    ${tw`lg:bg-neutrals-n1`}
    ${tw`backdrop-blur-lg`}
  }
  :not(.isSticky) ${StyledContainer} {
    ${tw`lg:pb-0`}
  }
  .isSticky ${StyledContainer} {
    ${tw`lg:pb-0`}
  }
  .isSticky ${StyledSecondaryMenuItem} {
    ${tw`lg:pb-[21px]`}
  }

  ${CTASectionDesktop} {
    ${({ showCTAsOnScroll }) => showCTAsOnScroll && tw`max-w-[0] opacity-0`}
  }

  .isSticky ${CTASectionDesktop} {
    ${({ showCTAsOnScroll }) => showCTAsOnScroll && tw`max-w-[999px] opacity-100 `}
  }
`;

export const StyledOverlay = styled.div<{ isMenuActive: boolean }>`
  ${tw`hidden`}
  ${tw`fixed inset-0 z-[21]`}
  ${tw`top-8 h-screen w-fullscreen`}
  ${tw`bg-ui-colours-ui3`}
  ${tw`opacity-70`}
  ${({ isMenuActive }) => (isMenuActive ? tw`lg:block` : tw`lg:hidden`)}
  ${tw`transition-[transform linear 0.2s]`}
`;
